
import { defineComponent, ref } from 'vue';
import VueBaseInput from './components/VueBaseInput.vue';

export default defineComponent({
  name: 'App',
  components: { VueBaseInput },
  setup() {
    const name = ref('');
    const password = ref('');
    const number = ref(0);
    const telephone = ref('');
    const email = ref('');
    const search = ref('');
    const message = ref('');
    const nickName = ref('');
    const emailError = ref('');

    const onInputButtonClick = () => {
      alert(nickName.value);
    };

    return { onInputButtonClick, name, password, number, telephone, email, search, message, nickName, emailError };
  },
});
